import {
  completeMonthPeriods,
  completeWeekPeriods,
  rolling30DaysPeriods,
  rolling7DaysPeriods,
  rollingTodayPeriods,
} from './constants';
import { CalendarOptionsProps } from './types';
import { CalendarOptionsButton } from './button';
import { AppTooltip } from '@components/ui/tooltip/tooltip';
import { SvgConsumer } from '@components/icons/svgConsumer';
import { useTranslation } from 'react-i18next';

export const CalendarOptions = ({ range, onChange }: CalendarOptionsProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'forms.default.date' });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <div className="mb-2 flex items-center gap-2">
          <p className="text-sm font-semibold text-neutral-700">{t('rollingWindows.title')}</p>
          <AppTooltip side="right" context={<p>{t('rollingWindows.tooltip')}</p>}>
            <span>
              <SvgConsumer className="text-m text-neutral-400" id="tooltip" />
            </span>
          </AppTooltip>
        </div>
        <div className="flex gap-1">
          {rollingTodayPeriods.map((el) => (
            <CalendarOptionsButton key={el} value={el} range={range} onChange={onChange} />
          ))}
        </div>
        <div className="flex gap-1">
          {rolling7DaysPeriods.map((el) => (
            <CalendarOptionsButton key={el} value={el} range={range} onChange={onChange} />
          ))}
        </div>
        <div className="flex gap-1">
          {rolling30DaysPeriods.map((el) => (
            <CalendarOptionsButton key={el} value={el} range={range} onChange={onChange} />
          ))}
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="mb-2 flex items-center gap-2">
          <p className="text-sm font-semibold text-neutral-700">{t('completePeriods.title')}</p>
          <AppTooltip side="right" context={<p>{t('completePeriods.tooltip')}</p>}>
            <span>
              <SvgConsumer className="text-m text-neutral-400" id="tooltip" />
            </span>
          </AppTooltip>
        </div>
        <div className="flex gap-1">
          {completeWeekPeriods.map((el) => (
            <CalendarOptionsButton key={el} value={el} range={range} onChange={onChange} />
          ))}
        </div>
        <div className="flex gap-1">
          {completeMonthPeriods.map((el) => (
            <CalendarOptionsButton key={el} value={el} range={range} onChange={onChange} />
          ))}
        </div>
      </div>
    </div>
  );
};
